<template>
  <v-card class="mx-5 mt-5">
    <!-- Tabella principale -->
    <v-data-table fixed-header :headers="headers" height="67vh" :items="items">
      <template v-slot:top>
        <v-toolbar color="indigo" dense>
          <v-row>
            <v-col align="left" cols="5">
              <v-toolbar-title class="white--text">
                Gestione Query Default
              </v-toolbar-title>
            </v-col>
            <v-col align="center" cols="2">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="aggiungiQuery" small v-bind="attrs" v-on="on">
                    <v-icon color="primary"> mdi-plus </v-icon>
                  </v-btn>
                </template>
                <span>Aggiungi</span>
              </v-tooltip>
            </v-col>
            <v-col align="right" cols="5">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="clickIndietro" small v-bind="attrs" v-on="on">
                    <v-icon color="error"> mdi-keyboard-backspace </v-icon>
                  </v-btn>
                </template>
                <span>Indietro</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-toolbar>
      </template>

      <!-- Bottone di modifica -->
      <template v-slot:[`item.modifica`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="clickModifica(item)" small v-bind="attrs" v-on="on">
              <v-icon color="primary"> mdi-pencil </v-icon>
            </v-btn>
          </template>
          <span>Modifica</span>
        </v-tooltip>
      </template>
      <!-- Bottone di eliminazione -->
      <template v-slot:[`item.elimina`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="clickElimina(item)" small v-bind="attrs" v-on="on">
              <v-icon color="error"> mdi-delete </v-icon>
            </v-btn>
          </template>
          <span>Elimina</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <!-- Dialog di aggiunta / modifica delle query -->
    <v-dialog v-model="modifica_dialog">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-row>
            <v-col align="left" cols="5">
              <v-toolbar-title class="white--text">
                Modifica Query Standard
              </v-toolbar-title>
            </v-col>
            <v-col align="center" cols="2">
              <!-- Bottone per chiudere il dialog -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="salvaModifica" small v-bind="attrs" v-on="on">
                    <v-icon color="success">mdi-floppy</v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>
            </v-col>
            <v-col align="right" cols="5">
              <!-- Bottone di salvataggio -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="chiudiDialogModifica"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="error">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Chiudi</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-toolbar>
        <v-card-text style="overflow-y: auto">
          <v-container>
            <v-row align="center" justify="center">
              <v-col cols="6">
                <v-text-field
                  label="Nome Tabella"
                  v-model="query_sel.nome_tabella"
                />
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col cols="12">
                <QueryEditor
                  @analyze="handleAnalyze"
                  v-model="query_sel"
                  :template="template"
                  :key="key_query_editor"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma eliminazione -->
    <v-dialog v-model="conferma_elimina_dialog" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Eliminazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler eliminare la query selezionata?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn class="mr-5" @click="chiudiConfermaElimina" small>
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="eliminaQuery" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import QueryEditor from "@/components/GRAPH/Dashboard/Editor/QueryParser/QueryEditor.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class QueryObject {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutti i campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "id_query", default_val: -1 },
      { nome: "nome_tabella", default_val: "" },
      { nome: "query", default_val: "" },
      { nome: "reset", default_val: this.reset },
      { nome: "setCampi", default_val: this.setCampi },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}

export default {
  name: "",
  components: { QueryEditor, SnackbarQV },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      key_query_editor: 0,
      query_sel: new QueryObject(),

      // Modal
      conferma_elimina_dialog: false,
      modifica_dialog: false,

      // Array
      headers: [
        { text: "Modifica", value: "modifica", sortable: false },
        { text: "Nome Tabella", value: "nome_tabella", sortable: false },
        { text: "Query", value: "query", sortable: false },
        { text: "Elimina", value: "elimina", sortable: false },
      ],
      items: new Array(),
      template: [
        {
          targetProperty: null,
          color: "red",
          keyword: "@",
          targetField: null,
          template: {},
        },
      ],
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    aggiungiQuery() {
      this.modifica_dialog = true;
      this.key_query_editor = this.key_query_editor === 0 ? 1 : 0;
    },
    chiudiConfermaElimina() {
      this.conferma_elimina_dialog = false;
      this.query_sel.reset();
    },
    chiudiDialogModifica() {
      this.modifica_dialog = false;
      this.query_sel.reset();
    },
    clickElimina(arg) {
      this.query_sel = new QueryObject(arg);
      this.conferma_elimina_dialog = true;
    },
    clickIndietro() {
      this.$router.push("/home");
    },
    clickModifica(arg) {
      this.query_sel = new QueryObject(arg);
      this.key_query_editor = this.key_query_editor === 0 ? 1 : 0;
      this.modifica_dialog = true;
    },
    eliminaQuery() {
      // Metto a 0 la validità della query selezionata.
      this.query_sel.validita = 0;

      // Preparo la request
      const request = {
        controller: "Label",
        method: "PUT",
        richiesta: {
          action: "setquerydefault",
          token: localStorage.user_token,
          query: [this.query_sel],
        },
      };

      // Consegno la request.
      this.$store
        .dispatch("api", request)
        .then(async (res) => {
          if (res.status === 200) {
            /* Chiudo il dialog di modifica, stampo una snackbar
             * di conferma, aggiorno i dati della tabella. */
            this.conferma_elimina_dialog = false;
            this.query_sel.reset();
            this.$refs.SnackbarQV.print(
              "success",
              "Query eliminata con successo."
            );
            this.getQueryDefault();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore tecnico durante l'eliminazione della query."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile eliminare la query."
          );
        });
    },
    getQueryDefault() {
      const request = {
        controller: "Label",
        method: "POST",
        richiesta: {
          action: "getquerydefault",
          token: localStorage.user_token,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items = new Array();
            res.data.forEach((e) => {
              this.items.push(e);
            });
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    handleAnalyze(arg) {
      console.log(JSON.stringify(arg));
    },
    async salvaModifica() {
      const request = {
        controller: "Label",
        method: "PUT",
        richiesta: {
          action: "setquerydefault",
          token: localStorage.user_token,
          query: [this.query_sel],
        },
      };

      return this.$store
        .dispatch("api", request)
        .then(async (res) => {
          if (res.status === 200) {
            this.modifica_dialog = false;
            await this.getQueryDefault();
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
  },
  created() {},
  mounted() {
    this.getQueryDefault();
  },
};
</script>
<style scoped>
</style>